export const ADVANCED_FILTER_BUTTON_ID = 'pa-advanced-filter';
export const PAGE_ACTION_MAIN_ID = 'pa-page-action-main';
export const PRESET_BUTTON_ID = 'pa-preset-button';
export const OTHER_ACTIONS_BUTTON_ID = 'pa-other-actions-button';
